import { Controller } from "@hotwired/stimulus"
import debounce from "utils/debounce"
import { screenSize } from "utils/screen_size"

export default class extends Controller {
  static targets = ['input']

  static values = {
    disableOn: String
  }

  initialize() {
    // https://discourse.stimulusjs.org/t/throttle-inside-a-controller/100
    this.resize = debounce(this.resize, 100)
  }

  connect() {
    this.resize()
  }

  resize(_event) {
    const disableOn = this.disableOnValue
    const size = screenSize()

    if ((disableOn === "mobile" && size === "xs") || (disableOn === "desktop" && !(size === "xs"))) {
      this.inputTarget.disabled = true
    } else {
      this.inputTarget.disabled = false
    }
  }
}
